// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"448ae3c2","239":"e39fb35b","319":"e361c96b","362":"abddb0ce","455":"1b991356"}[chunkId] + ".chunk.js";
};